// extracted by mini-css-extract-plugin
export default {"balance":"Balance_balance__41oSS","balance__title":"Balance_balance__title__g2lG2","balance__total":"Balance_balance__total__hLzWA"};